import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/_/voter-file-stats")({
	component: () => <Outlet />,
});
